// This icon file is generated automatically.
var PPlusCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M9.88 6.5H7.5V4.12A.13.13 0 007.37 4h-.75a.13.13 0 00-.12.13V6.5H4.12a.13.13 0 00-.12.13v.75c0 .06.06.12.13.12H6.5v2.38c0 .06.06.12.13.12h.75c.06 0 .12-.06.12-.13V7.5h2.38c.06 0 .12-.06.12-.13v-.75a.13.13 0 00-.13-.12z" } }, { "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }] }] }, "name": "p-plus-circle", "theme": "outlined" };
export default PPlusCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPlusCircleOutlined.js
// module id = 3540
// module chunks = 0